export enum TooltipTitleBlock {
  Root = 'TooltipTitle',
}

export enum TooltipTitleModifier {
  Highlighted = 'highlighted',
  LinkStyle = 'linkStyle',
}
